import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import { RequerimientosAcademicosComponent } from '../requerimientos-academicos/requerimientos-academicos.component';
import { AgregarEditarRegistroComponent } from '../agregar-editar-registro/agregar-editar-registro';
import { CarreraModel } from 'app/modules/models/carreras.model';
import { MatIconModule } from '@angular/material/icon';
import { BitacoraComponent } from '../bitacora/bitacora.component';

@Component({
    selector: 'app-detalle-registro',
    templateUrl: 'detalle-registro.component.html',
    standalone: true,
    imports:[
        MatTabsModule,
        MatIconModule,
        //Components
        RequerimientosAcademicosComponent,
        AgregarEditarRegistroComponent,
        BitacoraComponent
    ]
})

export class DetalleRegistroComponent implements OnInit {
    carreaModel = new CarreraModel();
    bitacoraTabLoaded = false;

    constructor(
        public _dialogRef: MatDialogRef<DetalleRegistroComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CarreraModel,
    ) {
        this.carreaModel = data
     }

    ngOnInit() { }

}
